import {createFileRoute} from '@tanstack/react-router';
import {z} from 'zod';

import {assetKeys} from '@/features/Asset/api/queryKeys';
import {getAssets} from '@/features/Asset/api/readAssets';
import {checklistTemplateKeys} from '@/features/Library/api/queryKeys';
import {getChecklistTemplates} from '@/features/Library/api/readChecklistTemplates';
import {NewProjectForm} from '@/features/Project/components/Form/CreateProjectForm';
import {makeDocumentTitle} from '@/utils/makeDocumentTitle';

export const Route = createFileRoute('/_b/_p/inspections/create')({
  component: NewProjectForm,

  validateSearch: z.object({
    asset: z.string().optional(),
  }),
  loaderDeps: ({search}) => ({...search}),

  beforeLoad: ({context}) => {
    makeDocumentTitle(`Create Inspection`);

    return {
      ...context,
      readAssetsQuery: {
        queryKey: assetKeys.lists(),
        queryFn: () => getAssets(),
      },
      readChecklistTemplatesQuery: {
        queryKey: checklistTemplateKeys.lists(),
        queryFn: () => getChecklistTemplates(),
      },
    };
  },

  loader({context}) {
    return Promise.all([
      context.queryClient.ensureQueryData(context.readAssetsQuery),
      context.queryClient.ensureQueryData(context.readChecklistTemplatesQuery),
    ]);
  },
});
